module.exports = __webpack_public_path__ + "img/stock1.28c571d3.png";